<template>
  <div class="FullPeriodIoInfo">
    <div v-if="list.length > 0">
      <full-period-io-info-web :list="list" class="hidden-sm-and-down" />
      <full-period-io-info-mob :list="list" class="hidden-md-and-up" />
    </div>
    <div v-else>
      <empty-list :state="stateList" />
    </div>
  </div>
</template>

<script>
import FullPeriodIoInfoWeb from "./FullPeriodIoInfoWeb.vue";
import FullPeriodIoInfoMob from "./FullPeriodIoInfoMob.vue";
import StateList from '../../../../model/StateList';
import TextUtils from "../../../../utils/TextUtils";
export default {
  components: {
    FullPeriodIoInfoWeb,
    FullPeriodIoInfoMob,
  },
  props: {
    args: Object,
  },
  mounted() {
    this.GetFullPeriodIoInfo();
  },
  data() {
    return {
      list: [],
      stateList: null,
    };
  },
  methods: {
    GetFullPeriodIoInfo() {
      //debugger
      this.list = [];
      this.stateList = StateList.loading();

      const params = new URLSearchParams();
      params.append("periodNumber", this.args.period);
      params.append("year", this.args.year);
      if (this.args.perno) {
        params.append("employeeId", this.args.perno);
      }
      // //debugger

      this.$store.dispatch("GetFullPeriodIoInfo", { params }).then((result) => {
        ////console.log(result);
        if (result.type === "success") {
          var data = [];
          data = result.data;
          this.list = data;
          this.stateList = null
        } else{
          this.stateList = StateList.error(result.error)
        }
      });
    },
    GetFullPeriodIoInfoParam(item) {
      // //debugger
      this.list = [];
      this.stateList = StateList.loading();

      const params = new URLSearchParams();
      params.append("periodNumber", item.MMonth);
      params.append("year", item.year);
      if (item.PERNO) {
        params.append("employeeId", TextUtils.convertToEnglishDigits(item.PERNO));
      }
      // //debugger

      this.$store.dispatch("GetFullPeriodIoInfo", { params }).then((result) => {
        ////console.log(result);
        if (result.type === "success") {
          var data = [];
          data = result.data;
          this.list = data;
          this.stateList = null
        } else{
          this.stateList = StateList.error(result.error)
        }
      });
    },
  },
};
</script>

<style>
</style>